// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		active = false,
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M12.2802064,14.3028965 L11.4627597,9.53681663 L14.9255194,6.16146012
					L10.1401032,5.46609844 L8,1.12977573 L5.8598968,5.46609844 L1.07448057,
					6.16146012 L4.53724029,9.53681663 L3.7197936,14.3028965 L8,12.0526588
					L12.2802064,14.3028965 Z"
			stroke="currentColor"
			fill={active? 'currentColor': 'transparent'}
			/>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Star.js